<template>
    <div class="relative w-full z-[100]" tabindex="1" @blur="closeMenu">
        <div @click="toggleMenu" id="headerLocationSelector" :class="[(vg_locationSelected.id)?'text-white':'text-[#878686]']" class="py-2 px-1 text-[#878686] flex items-center mt-2 rounded-md select-none cursor-pointer w-full">
            <div class='pl-2'>
                <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00033 0.666504C2.77533 0.666504 0.166992 3.27484 0.166992 6.49984C0.166992 10.8748 6.00033 17.3332 6.00033 17.3332C6.00033 17.3332 11.8337 10.8748 11.8337 6.49984C11.8337 3.27484 9.22533 0.666504 6.00033 0.666504ZM1.83366 6.49984C1.83366 4.19984 3.70033 2.33317 6.00033 2.33317C8.30033 2.33317 10.167 4.19984 10.167 6.49984C10.167 8.89984 7.76699 12.4915 6.00033 14.7332C4.26699 12.5082 1.83366 8.87484 1.83366 6.49984ZM3.91699 6.49984C3.91699 5.34924 4.84973 4.4165 6.00033 4.4165C6.74463 4.4165 7.43239 4.81358 7.80454 5.45817C8.1767 6.10276 8.1767 6.89692 7.80454 7.5415C7.43239 8.18609 6.74463 8.58317 6.00033 8.58317C4.84973 8.58317 3.91699 7.65043 3.91699 6.49984Z" fill="white"/>
                </svg>
            </div>
            <div class="flex-1 inline-flex flex-col justify-center items-start pl-2 gap-1">
                <div class="self-stretch truncate h-4 justify-center text-white text-sm font-normal font-['Roboto'] leading-5">{{ vg_locationSelected.name ? vg_locationSelected.name: 'Select A Location' }}</div>
                <div v-if="vg_locationSelected.businessBrandProfile" class="self-stretch truncate h-3.5 justify-center text-neutral-400 text-[10px] font-semibold font-['Roboto'] leading-4">{{ vg_locationSelected.businessBrandProfile?.name  }}</div>
                <div v-else class="self-stretch inline-flex justify-start items-center gap-1">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.60753 12.2492H11.3925C12.2909 12.2492 12.8509 11.275 12.4017 10.4992L8.0092 2.91C7.56003 2.13417 6.44003 2.13417 5.99086 2.91L1.59836 10.4992C1.1492 11.275 1.7092 12.2492 2.60753 12.2492ZM7.00003 8.16583C6.6792 8.16583 6.4167 7.90333 6.4167 7.5825V6.41583C6.4167 6.095 6.6792 5.8325 7.00003 5.8325C7.32086 5.8325 7.58336 6.095 7.58336 6.41583V7.5825C7.58336 7.90333 7.32086 8.16583 7.00003 8.16583ZM7.58336 10.4992H6.4167V9.3325H7.58336V10.4992Z" fill="#EF4444"/>
                    </svg>
                    <div class="flex-1 justify-center text-red-500 text-[10px] font-semibold font-['Roboto'] leading-4">Add to a Brand Profile</div>
                </div>
            </div>
            <div class="px-1">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.41 0.294922L6 4.87492L10.59 0.294922L12 1.70492L6 7.70492L0 1.70492L1.41 0.294922Z" fill="white"/>
                </svg>
            </div>
        </div>

        <transition v-show="toggle" enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
            <div class="absolute right-0 z-10 w-full origin-top-right rounded-md shadow-lg ring-1 bg-[#1C1D21] ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                <div class="text-white">
                    <div class="text-white max-h-[200px] overflow-y-auto">
                        <div v-for="location in locations" :key="location.id" class="w-full bg-zinc-700 shadow-[0px_5px_5px_0px_rgba(0,0,0,0.20)] shadow-[0px_3px_14px_0px_rgba(0,0,0,0.12)] shadow-[0px_8px_10px_0px_rgba(0,0,0,0.14)] inline-flex flex-col justify-start items-start overflow-hidden">
                            <!-- <div @click="selectTheLocation(location)" class="break-words cursor-pointer transition ease-out duration-100 text-sm hover:bg-theme-green/[0.5]">{{location.name}}</div> -->
                            <div @click="selectTheLocation(location)" class="w-full overflow-hidden px-2 py-1 inline-flex flex-col justify-center items-start break-words cursor-pointer transition ease-out duration-100 text-sm hover:bg-theme-green/[0.5]" :class="(vg_locationSelected.id==location.id)?'bg-secondary/[0.33]':'bg-theme-modalbg'">
                                <div class="self-stretch justify-start text-white text-sm font-normal font-['Roboto'] leading-5 line-clamp-2">{{location.name}}</div>
                                <div v-if="location.businessBrandProfile" class="self-stretch justify-start text-neutral-400 text-[10px] font-semibold font-['Roboto'] leading-4">{{ location.businessBrandProfile?.name }}</div>
                                <div v-else class="self-stretch inline-flex justify-start items-center gap-1">
                                    <div class="flex-1 justify-center text-red-500 text-[10px] font-semibold font-['Roboto'] leading-4">Add to a Brand Profile</div>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.60741 12.2492H11.3924C12.2907 12.2492 12.8507 11.275 12.4016 10.4992L8.00907 2.91C7.55991 2.13417 6.43991 2.13417 5.99074 2.91L1.59824 10.4992C1.14907 11.275 1.70907 12.2492 2.60741 12.2492ZM6.99991 8.16583C6.67907 8.16583 6.41657 7.90333 6.41657 7.5825V6.41583C6.41657 6.095 6.67907 5.8325 6.99991 5.8325C7.32074 5.8325 7.58324 6.095 7.58324 6.41583V7.5825C7.58324 7.90333 7.32074 8.16583 6.99991 8.16583ZM7.58324 10.4992H6.41657V9.3325H7.58324V10.4992Z" fill="#EF4444"/>
                                    </svg>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                    <div v-if="vg_isUserTypeSuper" @click="newLocation">
                        <div  class="border-t border-theme-grey text-theme-green bg-theme-modalbg cursor-pointer px-2 text-md align-baseline"><span class="text-3xl">+</span> <span class="align-bottom leading-9">New Location</span></div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { LocationMarkerIcon } from '@heroicons/vue/outline'
import { mapGetters, mapMutations} from "vuex";
import store from "@/store";

export default defineComponent({
    components: {
        LocationMarkerIcon
    },
    setup() {
        const locations = ref([])
        const toggle = ref(false)

        return {locations, toggle}
    },
    mounted(){
        if(this.vg_locations && this.vg_locations.length>0){
            this.locations = this.vg_locations?.sort((a, b) => a.name.localeCompare(b.name))
        }
    },
    watch: {
        vg_locations(){
            if(this.vg_locations && this.vg_locations.length>0){
                this.locations = this.vg_locations?.sort((a, b) => a.name.localeCompare(b.name))
            }else{
                this.locations = []
            }
        },
    },
    computed: {
        ...mapGetters({
            vg_locations: "location/list",
            vg_modified: 'modifiedForm/status',
            vg_auditCompleted: "audit/completed",
            vg_purchaseOrderWarn:"purchaseOrderWarn/show",
            vg_isUserTypeSuper: "auth/isUserTypeSuper",
            vg_locationSelected: "location/selected",
        })
    },
    methods: {
        toggleMenu(){
            this.toggle = !this.toggle
        },
        closeMenu(){
            this.toggle = false
        },
        newLocation(){
            this.$emit('clickNewlocation')
            this.closeMenu()
        },
        async selectTheLocation(location){
            if(this.vg_modified){
                await store.dispatch("confirmNew/confirmNew", {
                    msg: "Leave?",
                    extraMsg:
                        "Are you sure you want to leave? Your changes have not been saved",
                    confirmText: "Yes",
                    confirmClass: "bg-white text-theme-red",
                    cancelText: "No",
                    cancelClass: "bg-theme-green text-white",
                    confirmLeft: true
                }).then(() => {
                    this.vm_modified(false)
                    this.closeMenu()
                    this.$emit('selectTheLocation', location)
                    
                }).catch((err) => {
                    console.log(err)
                })
            }else if(!this.vg_auditCompleted){
                await store.dispatch("confirmNew/confirmNew", {
                    msg: "Exit",
                    extraMsg:
                    "Are you sure you want to leave without completing the audit?",
                    confirmText: "Yes, Exit",
                    confirmClass: "bg-theme-red hover:bg-opacity-70 text-white",
                }).then(async () => {
                    this.vm_auditCompleted(true)
                    this.closeMenu()
                    await this.$emit('selectTheLocation', location, '/audits')
                }).catch((err) => {
                    console.log(err)
                })
            }else if(this.vg_purchaseOrderWarn){
                await store.dispatch("confirmNew/confirmNew", {
                    msg: "Cancel",
                    extraMsg:
                        "This Purchase Order is in progress, are you sure you want to leave? Your Progress is saved and you can return at any time.",
                    confirmText: "Yes",
                    confirmClass: "bg-[#DC3545] text-white",
                }).then(async () => {
                    this.vm_purchaseOrderWarn(false);
                    this.closeMenu()
                    await this.$emit('selectTheLocation', location, '/purchase-orders-v2')
                }).catch(e => {
                    console.log(e)
                })
            }else{
                this.closeMenu()
                this.$emit('selectTheLocation', location)
            }
        },
        ...mapMutations({
            vm_modified: 'modifiedForm/mutateStatus',
            vm_auditCompleted: 'audit/mutateAudit',
            vm_purchaseOrderWarn: 'purchaseOrderWarn/mutatePurchaseOrderWarning'
        }),
    }
})
</script>
